import React, { useState } from 'react'

import { constants } from '@blocktickets/shared-utils'

import {
  formatCurrency,
  formatTicketGroups,
  formatTicketLocationValue,
} from '../../../../../utilities/helpers'
import { useOrderActions } from '../../../../../utilities/hooks/useOrderActions'

import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'

import { OrderActionsDropdown } from '../../../../SearchOrdersWrapper/OrdersList/OrderSummary/OrderSummary'

function getSectionRowSeats(order) {
  const tickets = order?.tickets || []
  const groups = formatTicketGroups(tickets) || []
  if (groups.length === 0) return { section: '—', row: '—', seats: '—' }
  const sections = [
    ...new Set(
      groups.map((g) =>
        String(
          formatTicketLocationValue(
            g.sectionNumber,
            g.generalAdmission ? 'GA' : ''
          )
        )
      )
    ),
  ].filter(Boolean)
  const rows = [
    ...new Set(
      groups.map((g) =>
        String(
          formatTicketLocationValue(g.rowNumber, g.generalAdmission ? 'GA' : '')
        )
      )
    ),
  ].filter(Boolean)
  const seats = [
    ...new Set(
      groups.map((g) =>
        String(
          formatTicketLocationValue(g.seats, g.generalAdmission ? 'GA' : '')
        )
      )
    ),
  ].filter(Boolean)

  return {
    section: sections.length ? sections.join(', ') : '—',
    row: rows.length ? rows.join(', ') : '—',
    seats: seats.length ? seats.join(', ') : '—',
  }
}

export default function Row({ order, setOrders, status, runSearch }) {
  const orderActions = useOrderActions(runSearch)

  const { ORDER_STATUS } = constants

  const sectionRowSeats = getSectionRowSeats(order)

  const [ticketsSent, setTicketsSent] = useState(
    order.status === ORDER_STATUS.COMPLETE_FROM_ASSIGNMENT || order.emailSent
  )

  const handleToggleChange = async (e) => {
    const { id, checked } = e.target
    const isChecked = checked

    if (isChecked) {
      try {
        const onSuccess = () => {
          setTicketsSent(true)
          // update actual order object so state is updated in dropdown menu.
          // Delivery says nothing about collection, so an order that still owes
          // a balance keeps its open or past due status.
          setOrders((prevOrders) => {
            return prevOrders.map((o) => {
              if (o.id === Number(id)) {
                return { ...o, emailSent: true }
              } else {
                return o
              }
            })
          })
        }
        orderActions.openConfirmSendTickets(order, onSuccess)
      } catch (error) {
        console.error('Error sending tickets:', error)
      }
    }
  }

  return (
    <div className="flex-row light" role="rowgroup">
      <div
        className="list-table-col px-2 text-truncate text-center lg"
        role="cell"
      >
        <span>{order?.purchasedByOrganizationName || 'N/A'}</span>
      </div>
      <div className="list-table-col px-2 text-truncate" role="cell">
        <span>{order?.email}</span>
      </div>
      <div
        className="list-table-col sm px-2 text-truncate"
        role="cell"
        title={sectionRowSeats.section}
      >
        <span>{sectionRowSeats.section}</span>
      </div>
      <div
        className="list-table-col sm px-2 text-truncate"
        role="cell"
        title={sectionRowSeats.row}
      >
        <span>{sectionRowSeats.row}</span>
      </div>
      <div
        className="list-table-col sm px-2 text-truncate"
        role="cell"
        title={sectionRowSeats.seats}
      >
        <span>{sectionRowSeats.seats}</span>
      </div>
      <div className="list-table-col sm px-2 text-truncate" role="cell">
        <span>{formatCurrency(order?.total)}</span>
      </div>
      <div className="list-table-col sm px-2 text-truncate" role="cell">
        <span>
          {formatCurrency(
            order?.status === ORDER_STATUS.OPEN ||
              order?.status === ORDER_STATUS.PAST_DUE
              ? order?.amountDue || order?.total
              : order?.amountDue
          )}
        </span>
      </div>
      <div className="list-table-col p-0 sm d-flex" role="cell">
        <Badge
          bg="none"
          className={`m-auto w-max-content badge--${status?.value}`}
        >
          {status?.label}
        </Badge>
      </div>
      <div className="list-table-col p-0 sm d-flex" role="cell">
        {/* disable if order is
          - tickets are sent (emailSent or complete from assignment status)
          - released, refunded, or reserved, so there is nothing left to deliver
          - stays enabled while a balance is owed (open, past due, payment plan) */}
        <div className="m-auto">
          <Form.Check
            type="switch"
            id={order?.id}
            aria-label="Tickets sent"
            checked={ticketsSent}
            disabled={
              ticketsSent ||
              order.status === ORDER_STATUS.RELEASED ||
              order.status === ORDER_STATUS.REFUNDED ||
              order.status === ORDER_STATUS.RESERVED
            }
            onChange={handleToggleChange}
          />
        </div>
      </div>
      <span className="btn-more-col btn-more-col--with-border" role="cell">
        <OrderActionsDropdown
          orderActions={orderActions}
          order={order}
          ticketsSent={ticketsSent}
          runSearch={runSearch}
          isFlexPack={order?.flex_pack}
        />
      </span>
    </div>
  )
}
